import { MaterialRequestRecord } from '../../../../types/MaterialRequest';
import React from 'react';
import { Tabs, TabsProps } from 'antd';
import MaterialRequestMovementTable from './MaterialRequestMovementTable';
import MaterialRequestIssuanceTable from './MaterialRequestIssuanceTable';
import MaterialRequestSummaryTable from './MaterialRequestSummaryTable';

interface MaterialRequestInfoTabsProp {
  data?: MaterialRequestRecord;
}
const MaterialRequestInfoTabs: React.FC<MaterialRequestInfoTabsProp> = ({
  data,
}) => {
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Movements',
      children: (
        <MaterialRequestMovementTable
          movementTable={data?.movements || []}
          recordId={data?.id}
          statusRecord={data?.status}
        />
      ),
    },
    {
      key: '2',
      label: 'Issuance',
      children: (
        <MaterialRequestIssuanceTable issuanceTable={data?.issuance || []} />
      ),
    },
    {
      key: '3',
      label: 'Summary',
      children: (
        <MaterialRequestSummaryTable summaryData={data?.summary || []} />
      ),
    },
  ];

  return (
    <>
      <Tabs defaultActiveKey="1" items={items} />
    </>
  );
};

export default MaterialRequestInfoTabs;
